// Constants.js

export const ACHIEVEMENTS_DATA = [
    { number: 5, label: "Years Experience" },
    { number: 500, label: "Successful Events" },
    { number: 10000, label: "Satisfied Clients" },
    { number: 200, label: "Talented Team" },
];

export const ACHIEVEMENTS_SETTINGS = {
    animationDuration: 1600,
    observerThreshold: 0.4,
};


// Constants.js

export const FLYERS_SECTION_CONTENT = {
    heading: "WEEKLY LINE UP",
    description: "Explore unparalleled themes throughout the week, from dusk rituals to after dark ravelry, as each night at Di Mora carries its own pulse",
    loadingText: "Loading Flyers...",
};

export const FLYERS_SETTINGS = {
    autoSlideInterval: 3000,
    collectionName: "new-flyers",
    orderField: "date",
    orderDirection: "asc",
};


// SERVICES SECTION CONTENT

export const SERVICES_SECTION_CONTENT = {
    headingLine1: "WHAT WE",
    headingLine2: "OFFER",
    description:
        "From exclusive VIP experiences and bespoke bachelorette celebrations to a refined lounge bar setting and professionally curated corporate events, the space adapts seamlessly to every occasion. Whether intimate or large-scale, each gathering is thoughtfully hosted, designed to deliver both atmosphere and precision.",
    buttonText: "CONTACT US",
    services: [
        "VIP SERVICES",
        "BACHELORETTE",
        "LOUNGE BAR",
        "CORPORATE EVENTS",
    ],
};


// ADDITIONAL SERVICES SECTION CONTENT

export const ADDITIONAL_SERVICE_CONTENT = {
    heading: "ADDITIONAL SERVICE",
    description:
        "Beyond our core experiences, the venue also accommodates birthday celebrations, curated photoshoots, relaxed lounge gatherings, and bespoke branded events making it larger than life experience ",
    buttonText: "CONTACT US",
    services: [
        {
            title: "BIRTHDAY PARTIES",
            desc: "Celebrate your big night with curated setups and dedicated service as we handle the details for you to own the spotlight.",
        },
        {
            title: "PHOTOSHOOT",
            desc: "Looking for a space that already feels like a set? Our interiors, lighting, and mood do half the work, you just bring the vision.",
        },
        {
            title: "LOUNGE AREA",
            desc: "Comfortable, stylish spaces designed for conversation and exclusivity. Step back without stepping out of the energy.",
        },
        {
            title: "BRANDED EVENTS",
            desc: "From product launches to curated takeovers, we create immersive brand experiences that feel seamless and on-point.",
        },
    ],
};


// HIGHLIGHT SECTION CONTENT

export const HIGHLIGHT_SECTION_CONTENT = {
    heading: "DEEP NIGHT LIGHT",
    description:
        "Unwind yourself to the mesmerising rituals of electrifying music, vibrant vibe and exotic aroma all week around ",
};


// TESTIMONIALS SECTION CONTENT

export const TESTIMONIALS_SECTION_CONTENT = {
    heading: "WHAT THEY SAY",
    testimonials: [
        {
            text:
                "Went to Di Mora on a friend’s recommendation and had a really good time. The place has a calm vibe, nothing loud or over the top. I honestly loved their menu — it has a good mix of options without feeling confusing. Everything we tried felt fresh and balanced. Would happily come back just to explore more dishes.",
            name: "Swapnil Kasle.",
            role: "Local Guide",
            img:
                "./assets/testimonial1.jpg",
        },
        {
            text:
                "Visited Dimora to try their new menu ! And it is surprisingly delicious. The truffle chips with the dip is simple and addictive. The sushi is perfect and well crafted . The paneer dishes and the dal makhani was great if you are looking for indian. Out favourite were the Yaki Soba noodles - mindblowing ! Their mocktails complement the menu perfectly.",
            name: "Palate at Pune",
            role: "Local Guide",
            img:
                "https://lh3.googleusercontent.com/a-/ALV-UjV9p7k0r9DzLrgKdNZ07HQb-Zan6hn-2M_y0Y1TZ6wsFhvYncE=w90-h90-p-rp-mo-ba3-br100",
        },
        {
            text:
                "Di mora… a dining spot… who would have thought? Lately visited them for lunch and boy oh boy was I blown away with their lunch menu. It’s GOURMET with all letters capital Who knew that the city’s most successful club would become a dining spot too The menu is a good mix of Indian fusion and Asian fusion too. I can go on and on but I’ll let the pictures do the talking. All I will say is that the food is super delicious and I can’t wait to return again to have more.",
            name: "Nishant Tulshan",
            role: "Local Guide",
            img:
                "https://templatekit.tokomoo.com/nightclubkit/wp-content/uploads/sites/70/2022/02/team-photo-3.jpg",
        },
    ],
};


// PUFFERY SECTION CONTENT

export const PUFFERY_SECTION_CONTENT = {
    headingLine1: "WHY ARE WE THE BEST",
    headingHighlight: "CLUB",
    headingLine2: "IN INDIA ?",

    descriptionPart1:
        "With a distinct Greek-Gods setting, a carefully structured weekly line-up, and experiences that range from VIP nights to curated private events, the club offers more than just a dance floor. Every detail from sound to service is designed with intention and care. It's not just where the city gathers, it’s where it returns.",


    descriptionPart2:
        "More than a nightclub, it is a cultural hub shaped by sound, design, and curated experiences throughout the week. Guests choose it not just for the music, but for the atmosphere, the crowd, and the consistency. A destination that defines the city after dark.",

    founderQuote:
        '"A restaurant or event is never just a place; it’s an experience. Our goal is to create destinations where design, culture, and hospitality come together."',

    founderName: "Siddhant Dhuwali",
    founderRole: "FOUNDER",

    meetHeading: "MEET THE FOUNDER",

    meetParagraphs: [
        "Siddhant Dhuwali is a visionary entrepreneur and the driving force behind some of Pune and Thane’s most iconic hospitality experiences. He is the founder of Di Mora Pune, Baglami, La Cena Thane, and Ignite with Blaze, an events company that curates high-energy, immersive experiences.",
        "Siddhant’s journey in hospitality began with a simple but ambitious vision: to transform dining and nightlife in India into experiences that go beyond food and drinks, creating memories and stories that last a lifetime. His approach combines culinary excellence, world-class mixology, cutting-edge design, and experiential storytelling, making each space he builds a destination in its own right.",
    ],
};


// CAREERS PAGE CONTENT

export const CAREERS_PAGE_CONTENT = {
    loveSection: {
        headingLine1: "YOU WILL LOVE",
        headingLine2: "WORKING HERE",
        description:
            "Working here means being at the center of the action where creativity, precision, and energy collide every night. From front-of-house to production and management, every role contributes to shaping memorable experiences as It’s fast, dynamic, and no two shifts ever feel the same. If you thrive under lights and love creating unforgettable nights, you’ll fit right in.",
        benefits: [
            "Competitive Earnings & Performance Incentives",
            "Career Progression & Skill Development",
            "Exclusive Access & Industry Networking",
        ],
    },

    testimonialSection: {
        heading: "WHAT THEY SAY",
        quote:
            '"Our team believes that working here is more than just a job—it’s an opportunity to grow, collaborate, and create experiences that truly matter. The culture encourages creativity, ownership, and a shared commitment to excellence."',
        author: "— Our Team Member",
    },

    openingsSection: {
        heading: "CURRENT OPENINGS",
        description:
            "Explore our available positions and start your journey with us.",
        loadingText: "Loading positions...",
        emptyText: "No open positions at the moment.",
        applyButton: "APPLY NOW",
        location: "Pune",
    },
};






// CONTACT INFO SECTION CONTENT

export const CONTACT_INFO_CONTENT = [
    {
        title: "EMAIL US",
        lines: ["Info@dimorapune.com"],
    },
    {
        title: "PHONE",
        lines: ["+91 70307 92020", "+91 70307 72020"],
    },
    {
        title: "OPEN HOURS",
        lines: ["Wednesday - Sunday from", "7:00 pm – 1:30 am "],
    },
    {
        title: "LOCATION",
        lines: ["Unit No 10, The Mills Sai Radhe Road, Raja Bahadur Motilal Rd, Pune, Maharashtra 411001"],
    },
];

export const PRESS_DATA = [
  {
    source: "Delhiites",
    logo: "https://pub-dc5215774265416a9110e4c88aef9f9d.r2.dev/imps/logo%201%20(2).png",
    quote: "⁠Delhiites Food & Nightlife Award Nightclub of the Year 2022 – Di Mora, Pune"
  },
  {
    source: "IHC",
    logo: "https://pub-dc5215774265416a9110e4c88aef9f9d.r2.dev/imps/image-removebg-preview%201.png",
    quote: "IHC London International Hospitality Day Award 2023 (IIHM)"
  },
  {
    source: "Times of India",
    logo: "https://pub-dc5215774265416a9110e4c88aef9f9d.r2.dev/imps/times-of-india%201.png",
    quote: "Times of India (Times Hospitality Icons)– Nightclub of the Year 2025, Di Mora, Pune"
  },
  {
    source: "IHC",
    logo: "https://pub-dc5215774265416a9110e4c88aef9f9d.r2.dev/imps/image-removebg-preview%201.png",
    quote: "IHC London Hospitality Honors List 2025 – Hotel, Restaurants & Travel (IIHM)"
  },
  {
    source: "Lokmat",
    logo: "https://pub-dc5215774265416a9110e4c88aef9f9d.r2.dev/imps/csm_16502-1592_import_ea501f3fe2-removebg-preview%201.png",
    quote: "⁠Lokmat One World Summit – Excellence Award for Iconic Hospitality Visionary of India (2026)"
  },
 
];